export enum ColorCSSVarEnum {
	// Base
	WHITE = '--white',
	BLACK = '--black',

	// Text
	TEXT_100 = '--text-100',
	TEXT_200 = '--text-200',
	TEXT_300 = '--text-300',
	TEXT_400 = '--text-400',
	TEXT_500 = '--text-500',

	// Surface (Background)
	SURFACE_100 = '--surface-100',
	SURFACE_200 = '--surface-200',
	SURFACE_300 = '--surface-300',
	SURFACE_400 = '--surface-400',
	SURFACE_500 = '--surface-500',
	SURFACE_600 = '--surface-600',

	// Line | Border
	LINE_100 = '--line-100',
	LINE_200 = '--line-200',
	LINE_300 = '--line-300',
	LINE_400 = '--line-400',

	// Brand
	BRAND_100 = '--brand-100',
	BRAND_200 = '--brand-200',
	BRAND_300 = '--brand-300',
	BRAND_400 = '--brand-400',
	BRAND_500 = '--brand-500',

	// Success
	SUCCESS_100 = '--success-100',
	SUCCESS_200 = '--success-200',
	SUCCESS_300 = '--success-300',
	SUCCESS_400 = '--success-400',
	SUCCESS_500 = '--success-500',

	// Error
	ERROR_100 = '--error-100',
	ERROR_200 = '--error-200',
	ERROR_300 = '--error-300',
	ERROR_400 = '--error-400',
	ERROR_500 = '--error-500',

	// Info
	INFO_100 = '--info-100',
	INFO_200 = '--info-200',
	INFO_300 = '--info-300',
	INFO_400 = '--info-400',
	INFO_500 = '--info-500',

	// Status
	STATUS_SUCCESS_50 = '--status-success-50',
	STATUS_SUCCESS_100 = '--status-success-100',
	STATUS_WARNING_50 = '--status-warning-50',
	STATUS_WARNING_100 = '--status-warning-100',
	STATUS_DANGER_50 = '--status-danger-50',
	STATUS_DANGER_100 = '--status-danger-100',
}
